export const EXSBSETTLEMENT_SHOW_RESET = 'EXSBSETTLEMENT_SHOW_RESET'
export const EXSBSETTLEMENT_SHOW_SET_ERROR = 'EXSBSETTLEMENT_SHOW_SET_ERROR'
export const EXSBSETTLEMENT_SHOW_SET_RETRIEVED = 'EXSBSETTLEMENT_SHOW_SET_RETRIEVED'
export const EXSBSETTLEMENT_SHOW_TOGGLE_LOADING = 'EXSBSETTLEMENT_SHOW_TOGGLE_LOADING'
